import {
  getControls,
  getSelectedDeviceData,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as AddNewDeviceIcon } from "../../assets/icons/add-device-icon.svg";
import { Link } from "../../components";
import Skeleton from "react-loading-skeleton";
import { VoiceControlCard } from "./VoiceControlCard";
import styles from "./VoiceControlsList.module.scss";
import { useEffect } from "react";
import { useFormatMessage } from "../../i18n";

export function VoiceControlsList() {
  const SKELETONS_DEVICE_COUNT = 4;
  const tr = useFormatMessage();
  const dispatch = useDispatch();
  const deviceSelected = useSelector(getSelectedDeviceData);

  const skeletons = Array(SKELETONS_DEVICE_COUNT)
    .fill()
    .map((_, idx) => <Skeleton key={idx} className={styles.skeleton} />);

  useEffect(() => {
    if (deviceSelected.status === "ok" && !deviceSelected.loaded) {
      dispatch(getControls(deviceSelected.cloudId));
    }
  }, [deviceSelected, dispatch]);

  const controls = [...deviceSelected.configured].sort(
    (prevControl, nextControl) =>
      parseInt(prevControl.id) - parseInt(nextControl.id)
  );
  return (
    <div className={styles.voiceControlsList}>
      {!deviceSelected.loading ? (
        <>
          {controls.map((control) => (
            <VoiceControlCard control={control} key={control.id} />
          ))}
          <div>
            <Link
              className={styles.addNewControlLink}
              to={`/voice/${deviceSelected.cloudId}/controls/new`}
            >
              <div className={styles.addNewControlIcon}>
                <AddNewDeviceIcon />
              </div>
              <div>
                <span>{tr("add_control")}</span>
              </div>
            </Link>
          </div>
        </>
      ) : (
        skeletons
      )}
    </div>
  );
}
